<template>
    <sweet-modal icon="warning" ref="deleteAnnouncementModal">
        <div v-if="selected !== null" class="text-center">
            <p class="mt-3" v-html="$t('pages.admin.livestream.announcements.delete.confirmation', {title: selected.title[$i18n.locale]})"></p>

            <delete-confirmation @clicked="deleteSelected">
                {{ $t('actions.delete') }}
            </delete-confirmation>
        </div>
    </sweet-modal>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue'
import DeleteConfirmation from "../../../../Includes/DeleteConfirmation";
import AdminLiveStreamAnnouncementRepository
    from "../../../../../repositories/Admin/AdminLiveStreamAnnouncementRepository";
export default {
    name: "AnnouncementDeleteModal",
    components: {DeleteConfirmation, SweetModal},
    props: {
        selected: {
            type: Object,
            default: null
        }
    },
    methods: {
        deleteSelected() {
            AdminLiveStreamAnnouncementRepository
                .delete(this.selected.id)
                .then((res) => {
                    this.$emit('announcement-deleted');
                    this.$refs.deleteAnnouncementModal.close();
                });
        }
    },
    watch: {
        selected: function (val) {
            if(val !== null)
                this.$refs.deleteAnnouncementModal.open();
        }
    }
}
</script>

<style scoped>

</style>
